import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'core-js/features/string/repeat';

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { RecaptchaConfigProvider } from './contexts/RecaptchaContext';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(
    <RecaptchaConfigProvider><App /></RecaptchaConfigProvider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
